//-- App -------------------------------------------------------------------------------------------------------------------------------
// Is app version up to date
export const versionCheckRequest = `/api/user/version-check`;
export const versionCheckRequestParams = (appVersion) => `${versionCheckRequest}?appVersion=${appVersion}`;
//-- User -------------------------------------------------------------------------------------------------------------------------------
// Authentication
export const login = () => "/api/user/login";
export const logout = () => "/api/user/logout";
export const requestVerify = () => "/api/user/requestverify";
export const verify = () => "/api/user/verify";
export const forgotPassword = () => "/api/user/forgotpassword";
export const resetPassword = () => "/api/user/resetpassword";
// User Data
export const getUserData = () => "/api/user/getuserdata";
//-- Office -------------------------------------------------------------------------------------------------------------------------------
export const officeReportsUrl = () => "/api/reports/office";
// Office Active Listings
export const activeListingsRequest = (officeId) => `${officeReportsUrl()}/active-listings?officeId=${officeId}`;
export const activeListingsRequestWithDate = (officeId, date) => {
    return `${officeReportsUrl()}/active-listings?officeId=${officeId}&date=${date}`;
};
export const activeListingsCsv = (officeId, date) => {
    return `${officeReportsUrl()}/active-listings-csv?officeId=${officeId}&date=${date}`;
};
// Office Leads
export const officeLeadsRequest = () => "/api/reports/office/leads";
export const officeLeadsRequestParams = (officeId, startDate, endDate) => {
    return `/api/reports/office/leads?officeId=${officeId}&startDate=${startDate}&endDate=${endDate}`;
};
export const officeLeadsRequestCsvParams = (officeId, startDate, endDate) => {
    return `/api/reports/office/leads-csv?officeId=${officeId}&startDate=${startDate}&endDate=${endDate}`;
};
// Office Agents
export const officeAgentsRequest = () => "/api/reports/office/agents";
export const officeAgentsRequestParams = (officeId, startDate, endDate) => {
    return `/api/reports/office/agents?officeId=${officeId}&startDate=${startDate}&endDate=${endDate}`;
};
export const officeAgentsRequestCsvParams = (officeId, startDate, endDate) => {
    return `/api/reports/office/agents-csv?officeId=${officeId}&startDate=${startDate}&endDate=${endDate}`;
};
// Office Stats
export const officeStatsRequest = () => "/api/reports/office/office-stats";
export const officeStatsRequestParams = (officeId, startDate, endDate) => {
    return `/api/reports/office/office-stats?officeId=${officeId}&startDate=${startDate}&endDate=${endDate}`;
};
// Office Overview
export const officeOverviewRequest = () => "/api/reports/office/office-overview";
export const officeOverviewRequestParams = (officeId, startDate, endDate) => {
    return `/api/reports/office/office-overview?officeId=${officeId}&startDate=${startDate}&endDate=${endDate}`;
};
//-- Agency -------------------------------------------------------------------------------------------------------------------------------
// Agency Overview
export const agencyOverviewRequest = () => "/api/reports/agency/overview";
export const agencyOverviewRequestParams = (agencyId, startDate, endDate) => {
    return `/api/reports/agency/overview?agencyId=${agencyId}&startDate=${startDate}&endDate=${endDate}`;
};
export const agencyOverviewRequestCsvParams = (agencyId, startDate, endDate) => {
    return `/api/reports/agency/overview-csv?agencyId=${agencyId}&startDate=${startDate}&endDate=${endDate}`;
};
//-- External -------------------------------------------------------------------------------------------------------------------------------
export const externalPath = "/api/external";
// Agency Overview
export const officeIdRequest = `${externalPath}/get-office-from-guid`;
export const officeIdRequestParams = (officeGuid) => `${officeIdRequest}?guid=${officeGuid}`;
//-- Widgets -------------------------------------------------------------------------------------------------------------------------------
export const widgetsPath = "/api/widgets";
export const featuredAgentRequest = `${widgetsPath}/featured-agent`;
export const featuredAgentRequestParams = (officeId) => `${featuredAgentRequest}?officeId=${officeId}`;
export const featuredListingRequest = `${widgetsPath}/featured-listing`;
export const featuredListingRequestParams = (officeId) => `${featuredListingRequest}?officeId=${officeId}`;
export const spotlightListingRequest = `${widgetsPath}/spotlight-listing`;
export const spotlightListingRequestParams = (officeId) => `${spotlightListingRequest}?officeId=${officeId}`;
//-- Products -------------------------------------------------------------------------------------------------------------------------------
export const productsPath = "/api/products";
export const orderHdListingsRequest = `${productsPath}/order-hd-listings`;
export const orderHdListingsRequestParams = (officeId) => `${orderHdListingsRequest}?officeId=${officeId}`;
